import { render } from "./ChartBar.vue?vue&type=template&id=6ec431ca&ts=true"
import script from "./ChartBar.vue?vue&type=script&lang=ts"
export * from "./ChartBar.vue?vue&type=script&lang=ts"

import "./ChartBar.vue?vue&type=style&index=0&id=6ec431ca&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__